<div class="errorContiner"  [ngSwitch]="type" [ngClass]="isMobile ? 'error_text_mobile': ''">
    <div class="errorText " *ngSwitchCase="'generalError'" [ngClass]="isMobile ? 'error_text_mobile': 'error_text'">
        <div class="title text_ml" [ngClass]="{'text_mm': isMobile}">
            {{'ERROR.GENERAL_ERROR.TITLE' | translate}}
        </div>
        <div class="text_xxl one_line" [ngClass]="{'text_l': isMobile}">
            {{'ERROR.GENERAL_ERROR.TEXT' | translate | translateCut:0}}
            <span  class="prettyLetters"  [ngClass]="{'text_xl': isMobile}">{{'ERROR.GENERAL_ERROR.TEXT' | translate | translateCut:1}}</span>
            {{'ERROR.GENERAL_ERROR.TEXT' | translate | translateCut:2}}
        </div>
    </div>
    <div class="errorText errorTextSmall " *ngSwitchCase="'finalize'" [ngClass]="isMobile ? 'mobile_success_text': 'error_text'">
        <div class="text_xxl" [ngClass]="{'text_ls': isMobile}">
            {{'ERROR.THANK_YOU.TITLE' | translate | translateCut:0}}
            <span  class="prettyLetters"  [ngClass]="isMobile ? 'text_xxl': 'text_xxxl'">{{'ERROR.THANK_YOU.TITLE' | translate | translateCut:1}}</span>
        </div>
        <div class="" [ngClass]="isMobile ? 'text_mm': 'text_l'">
            {{'ERROR.THANK_YOU.TEXT_1' | translate : {date: scheduleDateAndTime?.date, time: scheduleDateAndTime?.time, propertyAddress: propertyAddress} | translateCut:0}}
            <span class="">{{'ERROR.THANK_YOU.TEXT_1' | translate : {date: scheduleDateAndTime?.date, time: scheduleDateAndTime?.time, propertyAddress: propertyAddress} | translateCut:1}}</span>
            <br>
            {{'ERROR.THANK_YOU.TEXT_1' | translate : {date: scheduleDateAndTime?.date, time: scheduleDateAndTime?.time, propertyAddress: propertyAddress}  | translateCut:2}}
            <span class="bolder" >{{'ERROR.THANK_YOU.TEXT_1' | translate  : {date: scheduleDateAndTime?.date, time: scheduleDateAndTime?.time, propertyAddress: propertyAddress} | translateCut:3}}</span>
            {{'ERROR.THANK_YOU.TEXT_1' | translate : {date: scheduleDateAndTime?.date, time: scheduleDateAndTime?.time, propertyAddress: propertyAddress} | translateCut:4}}
            <span class="bolder" >{{'ERROR.THANK_YOU.TEXT_1' | translate : {date: scheduleDateAndTime?.date, time: scheduleDateAndTime?.time, propertyAddress: propertyAddress} | translateCut:5}}</span>
            {{'ERROR.THANK_YOU.TEXT_1' | translate : {date: scheduleDateAndTime?.date, time: scheduleDateAndTime?.time, propertyAddress: propertyAddress} | translateCut:6}}
        </div>
        <div class="primaryColor " [ngClass]="isMobile ? 'text_mm': 'text_ml'">
            {{'ERROR.THANK_YOU.TEXT_2' | translate}}
        </div>
    </div>
    <div class="errorText checkInText" *ngSwitchCase="'check-in'" [ngClass]="isMobile ? 'error_text_mobile': 'error_text'">
        <div class="backArrow">
            <img src="./assets/img/Back.svg" alt="" class="backArrowImage" (click)="back()" [ngClass]="{'backArrowImageMobile': isMobile}">
        </div>
        <div class="body">
            <div class="title text_xxl" [ngClass]="{'text_ls mobileTitle': isMobile}">
                {{'ERROR.CHECK_IN.TITLE' | translate | translateCut:0}}
                <span  class="prettyLetters prettyLettersBig"  [ngClass]="{'one_line': isMobile}">{{'ERROR.CHECK_IN.TITLE' | translate | translateCut:1}}</span>
            </div>
            <div class="address" [ngClass]="{'mobileAddress': isMobile}">{{propertyAddress}}</div>
            <div class="stepsBox" [ngClass]="{'mobileStepsBox': isMobile}">
                <div class="stepBox">
                    <div class="stepBoxTitle">{{'ERROR.CHECK_IN.STEP_1_TITLE' | translate}}</div>
                    <div class="stepBoxText" [ngClass]="{'stepBoxTextMobile': isMobile}">{{'ERROR.CHECK_IN.STEP_1_TEXT' | translate}}</div>
                </div>
                <div class="stepBox">
                    <div class="stepBoxTitle">{{'ERROR.CHECK_IN.STEP_2_TITLE' | translate}}</div>
                    <div class="stepBoxText" [ngClass]="{'stepBoxTextMobile': isMobile}">{{'ERROR.CHECK_IN.STEP_2_TEXT' | translate}}</div>
                </div>
            </div>
            <div class="remark" [ngClass]="{'remarkMobile': isMobile}">
                <div>{{'ERROR.CHECK_IN.HAVING_TROUBLE_TEXT' | translate}}</div>
                <div class="pointer" (click)="call()">{{'ERROR.CHECK_IN.HAVING_TROUBLE_DISPLAY_PHONE' | translate}}</div>
            </div>
        </div>
    </div>
    <div class="errorText checkInText" *ngSwitchCase="'check-out'" [ngClass]="isMobile ? 'error_text_mobile': 'error_text'">
        <div class="backArrow">
            <img src="./assets/img/Back.svg" alt="" class="backArrowImage" (click)="back()" [ngClass]="{'backArrowImageMobile': isMobile}">
        </div>
        <div class="body">
            <div class="title text_xxl" [ngClass]="{'text_ls mobileTitle': isMobile}">
                {{'ERROR.CHECK_OUT.TITLE' | translate | translateCut:0}}
                <span  class="prettyLetters prettyLettersBig"  [ngClass]="{'one_line': isMobile}">{{'ERROR.CHECK_OUT.TITLE' | translate | translateCut:1}}</span>
            </div>
            <div class="sub_title" [ngClass]="{'mobileSub_title': isMobile}">{{'ERROR.CHECK_OUT.SUB_TITLE' | translate}}</div>
        </div>
       
    </div>
    <div class="errorText" *ngSwitchDefault>
        <div class="text_xxxl" [ngClass]="{'text_xl': isMobile}">
            {{'ERROR.ERROR_404.TITLE' | translate}}
        </div>
        <div class="text_xl" [ngClass]="{'text_mm': isMobile}">
            {{'ERROR.ERROR_404.TEXT' | translate}}
        </div>
    </div>
</div>

<div class="buttonsContiner"  *ngIf="type === 'generalError' || type === 'finalize' || type === 'check-in'"> 
    <div class="buttonsRow" [ngClass]="{'mobileButtonsRow': isMobile}">
        <!-- <button class="home365-button primary flex center-vr" [ngClass]="{'home365-mobile-button': isMobile}" *ngIf="type === 'check-in'" (click)="checkOut()">
            {{'MY_SHOWINGS.CHECK_OUT_BUTTON' | translate}}
        </button> -->
        <button class="home365-button primary flex center-vr" [ngClass]="{'home365-mobile-button': isMobile}" *ngIf="type != 'check-in'">
            <span *ngIf="type != 'finalize'" (click)="retray()">
                {{'GENERAL_TEXTS.RETRY_BUTTON' | translate}}
            </span>
        </button>
        <button  *ngIf="type === 'check-out'" class="home365-button primary flex center-vr inverted" [ngClass]="{'home365-mobile-button': isMobile}"(click)="apply()">
            {{'MY_SHOWINGS.APPLY_BUTTON' | translate}}
        </button>
        
    </div>
</div>

<div class="loadingContainer" *ngIf="loading">
    <mat-spinner diameter="70"></mat-spinner>
</div>